export enum UserRoleEnum {
  organization = 'organization',
  sbf_master = 'sbf_master',
  sbs_sales = 'sbs_sales',
  sbs_tag_team = 'sbs_tag_team',
  sbs_operation = 'sbs_operation',
  wedding = 'wedding',
}

export type Cookies = Record<string, string>;

export type CookieNames = Record<string, string>;

export interface CookiesInfo {
  tokenUserName: string;
  idToken: string;
  accessToken: string;
  refreshToken: string;
  userData: string;
}

export interface UserData {
  Username: string;
  UserAttributes: { Name: string; Value: UserRoleEnum }[];
}

export interface UserInformation {
  userName: string;
  name: string | undefined;
  role: UserRoleEnum | undefined;
  organizationId: string | undefined;
  saleAreaId: string | undefined;
}
